(function (p12295, p12296) {
  if (true) {
    module.exports = p12296();
  } else {
    undefined;
  }
})(this, function () {
  'use strict';

  function f1550() {
    return function (p12297) {
      var vLN01556 = 0;
      var vLN01557 = 0;
      var vLN01558 = 0;
      var vLN1142 = 1;
      if (p12297.length == 0) {
        p12297 = [+new Date()];
      }
      var vIi35 = f1552();
      vLN01556 = vIi35(" ");
      vLN01557 = vIi35(" ");
      vLN01558 = vIi35(" ");
      for (var vLN01559 = 0; vLN01559 < p12297.length; vLN01559++) {
        vLN01556 -= vIi35(p12297[vLN01559]);
        if (vLN01556 < 0) {
          vLN01556 += 1;
        }
        vLN01557 -= vIi35(p12297[vLN01559]);
        if (vLN01557 < 0) {
          vLN01557 += 1;
        }
        vLN01558 -= vIi35(p12297[vLN01559]);
        if (vLN01558 < 0) {
          vLN01558 += 1;
        }
      }
      vIi35 = null;
      function f1551() {
        var v9733 = vLN01556 * 2091639 + vLN1142 * 2.3283064365386963e-10;
        vLN01556 = vLN01557;
        vLN01557 = vLN01558;
        return vLN01558 = v9733 - (vLN1142 = v9733 | 0);
      }
      f1551.next = f1551;
      f1551.uint32 = function () {
        return f1551() * 4294967296;
      };
      f1551.fract53 = function () {
        return f1551() + (f1551() * 2097152 | 0) * 1.1102230246251565e-16;
      };
      f1551.version = "Alea 0.9";
      f1551.args = p12297;
      f1551.exportState = function () {
        return [vLN01556, vLN01557, vLN01558, vLN1142];
      };
      f1551.importState = function (p12298) {
        vLN01556 = +p12298[0] || 0;
        vLN01557 = +p12298[1] || 0;
        vLN01558 = +p12298[2] || 0;
        vLN1142 = +p12298[3] || 0;
      };
      return f1551;
    }(Array.prototype.slice.call(arguments));
  }
  function f1552() {
    var vLN4022871197 = 4022871197;
    function f1553(p12299) {
      p12299 = p12299.toString();
      for (var vLN01560 = 0; vLN01560 < p12299.length; vLN01560++) {
        vLN4022871197 += p12299.charCodeAt(vLN01560);
        var v9734 = vLN4022871197 * 0.02519603282416938;
        vLN4022871197 = v9734 >>> 0;
        v9734 -= vLN4022871197;
        v9734 *= vLN4022871197;
        vLN4022871197 = v9734 >>> 0;
        v9734 -= vLN4022871197;
        vLN4022871197 += v9734 * 4294967296;
      }
      return (vLN4022871197 >>> 0) * 2.3283064365386963e-10;
    }
    f1553.version = "Mash 0.9";
    return f1553;
  }
  f1550.importState = function (p12300) {
    var v9735 = new f1550();
    v9735.importState(p12300);
    return v9735;
  };
  return f1550;
});